// 'morning' 5am to before 12noon
// 'noon' 12pm to before 5pm
// 'evening' 5pm to before 9pm
// 'night' Between 9pm and 5am
export const getGreetingRemoteStringKey = () => {
  const currentHour = new Date().getHours()

  if (currentHour >= 5 && currentHour < 12) {
    return 'acorns_intelligence.chat.intro.morning.variable'
  } else if (currentHour >= 12 && currentHour < 17) {
    return 'acorns_intelligence.chat.intro.noon.variable'
  } else if (currentHour >= 17 && currentHour < 21) {
    return 'acorns_intelligence.chat.intro.evening.variable'
  } else {
    return 'acorns_intelligence.chat.intro.night.variable'
  }
}
